import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { PushNotificationService } from '@shared/services/push-notification.service';

export const fcmRegistrationGuard: CanActivateFn = () => {
  void inject(PushNotificationService).register();
  return true;
};
